__turbopack_context__.v({
  "backgroundLayer": "ImageSection-module__A2VFRW__backgroundLayer",
  "heading": "ImageSection-module__A2VFRW__heading",
  "line": "ImageSection-module__A2VFRW__line",
  "section": "ImageSection-module__A2VFRW__section",
  "textContainer": "ImageSection-module__A2VFRW__textContainer",
  "vignette": "ImageSection-module__A2VFRW__vignette",
});
